const CONTAINER_SELECTOR = '.password-container';
const ICON_SELECTOR_HIDDEN = '.mdi-eye-outline';
const ICON_SELECTOR_VISIBLE = '.mdi-eye-off-outline';

const PasswordInput = {
    init: ($scope) => {
        if (!$scope) {
            $scope = $(document);
        }

        $scope.on('click', CONTAINER_SELECTOR + ' i' , function (evt) {
            evt.preventDefault();

            const input = $(this).closest(CONTAINER_SELECTOR).find('input');

            if (input.attr('type') === 'password') {
                // Change the password input to text and open the eye icon
                input.attr('type', 'text');
                $(this).addClass(ICON_SELECTOR_VISIBLE.substring(1));
                $(this).removeClass(ICON_SELECTOR_HIDDEN.substring(1));
            } else if (input.attr('type') === 'text') {
                // Change the text input to password and close the eye icon
                input.attr('type', 'password');
                $(this).addClass(ICON_SELECTOR_HIDDEN.substring(1));
                $(this).removeClass(ICON_SELECTOR_VISIBLE.substring(1));
            }
        });
    },
};

export default PasswordInput;
